import * as ActionType from '../types/website/PageActionTypes';
import * as NotificationActions from '../NotificationActions';

function requestPages() {
  return {
    type: ActionType.REQUEST_PAGES
  };
}

function receivePages(json) {
  return {
    type: ActionType.RECEIVE_PAGES,
    payload: {
      pages: json
    }
  };
}

function receiveHiddenPageSuggestions(json) {
  return {
    type: ActionType.RECEIVE_HIDDEN_PAGE_SUGGESTIONS,
    payload: {
      hiddenSuggestions: json
    }
  };
}

function receivePage(json) {
  return {
    type: ActionType.RECEIVE_PAGE,
    payload: {
      page: json
    }
  };
}

export const activatePage = activePage => (dispatch) => {
  dispatch({ type: ActionType.ACTIVATE_PAGE, activePage });
};

export function fetchPages() {
  return (dispatch) => {
    dispatch(requestPages());
    return fetch('/web-api/v1/cms/page/list',
      {
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(receivePages(json)));
  };
}

export function fetchHiddenPageSuggestions() {
  return dispatch => (
    fetch('/web-api/v1/cms/page/hiddensuggestions',
      {
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(receiveHiddenPageSuggestions(json)))
  );
}

export function reorderPages() {
  return (dispatch, getState) => (
    fetch('/web-api/v1/cms/page/list/reorder',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(getState().website.pages.orderedIds)
      })
      .then(response => response.json())
      .then(json => dispatch(receivePages(json)))
  );
}

export const movePage = (oldIndex, newIndex) => (dispatch) => {
  dispatch({ type: ActionType.MOVE_PAGE, oldIndex, newIndex });
  dispatch(reorderPages());
};

export function updatePageVisibility(pageId) {
  return (dispatch, getState) => (
    fetch(`/web-api/v1/cms/page/id/${pageId}/hidden`,
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
          hidden: getState().website.pages.byId[pageId].hidden
        })
      })
      .then(response => response.json())
      .then(json => dispatch(receivePage(json)))
      .then(() => {
        const message = getState().website.pages.byId[pageId].hidden ? 'Hidden' : 'Visible';
        dispatch(NotificationActions.confirmation({ message: `Page ${message}` }));
      })
  );
}

export const togglePage = id => (dispatch) => {
  dispatch({ type: ActionType.TOGGLE_PAGE, payload: { id } });
  dispatch(updatePageVisibility(id));
};

export function toggleHiddenPageSuggestion(pageId, hidden) {
  return dispatch => (
    fetch(`/web-api/v1/cms/page/id/${pageId}/hidden`,
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
          hidden
        })
      })
      .then(response => response.json())
      .then(() => {
        const message = hidden ? 'Hidden' : 'Visible';
        dispatch(NotificationActions.confirmation({ message: `Page ${message}` }));
      })
  );
}

export function updatePage(pageView) {
  return dispatch => (
    fetch('/web-api/v1/cms/page',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(pageView)
      })
      .then(response => response.json())
      .then(json => dispatch(receivePage(json)))
      .then(() => dispatch(NotificationActions.confirmation({ message: 'Page Updated' })))
  );
}

export function bulkUpdateCmsPageVisibility(pages) {
  return dispatch => (
    fetch('/web-api/v1/cms/page/list/bulkupdate',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(pages)
      })
      .then(() => dispatch(fetchPages()))
  );
}



// WEBPACK FOOTER //
// ./src/actions/website/PageActions.js